import linkifyHtml from "linkify-html"
const options = { defaultProtocol: "https", target: "_blank" }

export const formatStrToHTML = (str: string) => {
  const sanitizedStr = str.replace(/</g, "&lt;").replace(/>/g, "&gt")
  return linkifyHtml(sanitizedStr, options)
}
